export function sbmHeader() {
    'use strict';
    $ = jQuery;
    if ($('.standard.sticky.navonly').length) {
        var position = $(window).scrollTop();
        $(window).bind('scroll', function () {
            var height = $("header").outerHeight();
            var scroll = $(window).scrollTop();
            if (scroll > position && scroll > height) {
                $(".mtpc_header.sbm .desktop .second_layer_wrapper").addClass('fixed_position');
                $(".mtpc_header.sbm .desktop .logos_container").addClass('minimized');
            } else {
                $(".mtpc_header.sbm .desktop .logos_container").removeClass('minimized', function () {
                    add_padding_top_to_layout_container();
                });
                $(".mtpc_header.sbm .second_layer_wrapper").removeClass('fixed_position');
                if (scroll <= height) {
                
                }
            }
            position = scroll;
        });
    }
}

function add_padding_top_to_layout_container() {
    $('.layout-container.sticky').css('padding-top', $("header").outerHeight() - 1);
}